import { Controller, useFormContext } from 'react-hook-form';

import { Switch } from 'antd';
import { type SwitchChangeEventHandler } from 'antd/es/switch';

import { ErrorMessage } from './ErrorMessage';

interface IProps {
  id: string;
  placeholder?: string;
  name: string;
  onClick?: SwitchChangeEventHandler;
}

export const Toggle = ({ id, name, onClick }: IProps) => {
  const { control } = useFormContext();

  return (
    <div>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field }) => <Switch id={id} {...field} onClick={onClick} />}
      />
      <ErrorMessage fieldName={name} />
    </div>
  );
};
